var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Trans } from 'react-i18next';
import { translate } from '../../../../strings/i18n';
import { NoteContainer, NoteWrapper } from './subcomponents';
var Note = function () { return (_jsx(NoteContainer, { children: _jsx(NoteWrapper, __assign({ all: "base", "data-testid": "sams-note" }, { children: _jsx(Trans, __assign({ i18nKey: "note" }, { children: translate('note') })) })) })); };
export default Note;
